import { RemovingDocumentErrorCode } from "@common/constants/financial-documents";
import { z } from "zod";

export const DocumentWithTransactionsSchema = z.object({
    fileName: z.string(),
    transactionsCount: z.number(),
});

export const RemovingDocumentWithTransactionsErrorSchema = z.object({
    code: z.literal(
        RemovingDocumentErrorCode.REMOVING_DOCUMENT_WITH_TRANSACTIONS,
    ),
    documents: z.array(DocumentWithTransactionsSchema),
});

export type RemovingDocumentWithTransactionsError = z.infer<
    typeof RemovingDocumentWithTransactionsErrorSchema
>;
